import {
  FilterInputBracket,
  FilterInputBudget,
  FilterInputCardtype,
  FilterInputColorId,
  FilterInputPreconCommander,
  FilterInputTag,
  FilterInputTimeframe,
  FilterLabel,
} from '@/components/common/Filter'
import { usePage } from '@/components/providers/PageProvider'

import styles from './FiltersPanel.module.scss'
import { FiltersPanelAdvanced } from './FiltersPanelAdvanced/FiltersPanelAdvanced'
import { FiltersPanelHeader } from './FiltersPanelHeader/FiltersPanelHeader'
import { FiltersPanelResetButton } from './FiltersPanelResetButton/FiltersPanelResetButton'

export const FiltersPanel = () => {
  const { page } = usePage()

  const route = page?.route
  const hasCardtype = !!page?.optionsFilters?.cardtypes
  const hasPreconCommanders = !!page?.optionsFilters?.preconCommanders
  const hasColorId = !!page?.optionsFilters?.colorIdMap
  const hasTimeframe = !!page?.optionsFilters?.timeframes
  const hasBracket = !!page?.optionsFilters?.brackets
  const hasBudget = !!page?.optionsFilters?.budgets
  const hasTag = !!page?.optionsFilters?.tags
  const hasAdvanced = !!page?.optionsFilters?.advanced

  return (
    <div className={styles.container}>
      <FiltersPanelHeader />
      <ul className={styles.list}>
        {hasCardtype && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='cardtype' />
            </div>
            <FilterInputCardtype />
          </li>
        )}
        {hasPreconCommanders && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='preconCommander' />
            </div>
            <FilterInputPreconCommander />
          </li>
        )}
        {hasColorId && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='colorId' />
            </div>
            <FilterInputColorId showCheckboxes />
          </li>
        )}
        {hasTimeframe && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='timeframe' />
            </div>
            <FilterInputTimeframe />
          </li>
        )}
        {hasBracket && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='bracket' />
            </div>
            <FilterInputBracket />
          </li>
        )}
        {hasBudget && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='budget' />
            </div>
            <FilterInputBudget />
          </li>
        )}
        {hasTag && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='tag' />
            </div>
            <FilterInputTag />
          </li>
        )}
        {hasAdvanced && (
          <li>
            <div className={styles.label}>
              <FilterLabel variant='advanced' />
              {!!route?.advancedFilters && <FiltersPanelResetButton route={{ advancedFilters: undefined }} />}
            </div>
            <FiltersPanelAdvanced />
          </li>
        )}
      </ul>
    </div>
  )
}
